import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_additional_safety_measures_in_place_relat'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_additional_safety_measures_in_place_relat',
  name: 'Does the facility have any additional safety measures in place related to the storage of chemicals and hazardous substances?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'CHEMICAL_STORAGE_AREAS_ARE_APPROPRIATELY_DESIGNED_CONSTRUCTED_A',
      text: 'Chemical storage areas are appropriately designed, constructed and located for the safe storage of chemicals and hazardous substances',
      externalIds: [
        {
          id: 'hs-26--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHEMICAL_STORAGE_AREAS_HAVE_MEASURES_IN_PLACE_TO_PREVENT_UNAUTH',
      text: 'Chemical storage areas have measures in place to prevent unauthorized entry',
      externalIds: [
        {
          id: 'hs-26--1-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WHEN_NOT_IN_USE_ALL_CHEMICAL_CONTAINERS_ARE_PROPERLY_CAPPED_AND',
      text: 'When not in use, all chemical containers are properly capped and stored away so as to prevent spillage, leakage, and unsafe exposure to workers',
      externalIds: [
        {
          id: 'hs-26--1-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHEMICAL_STORAGE_AREAS_WITH_FLAMMABLE_CHEMICALS_ARE_EQUIPPED_WI',
      text: 'Chemical storage areas with flammable chemicals are equipped with an automatic fire extinguishing system',
      externalIds: [
        {
          id: 'hs-26--1-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'IN_CASES_OF_EMERGENCY_THERE_ARE_EASY_ENTRY_IES_AND_EXIT_S_TO_AL',
      text: 'In cases of emergency, there are easy entry(ies) and exit(s) to all chemical storage areas',
      externalIds: [
        {
          id: 'hs-26--1-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHEMICAL_STORAGE_AREAS_HAVE_AN_ALARM_NOTIFICATION_SYSTEM',
      text: 'Chemical storage areas have an alarm notification system',
      externalIds: [
        {
          id: 'hs-26--1-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-26--1-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'CHEMICAL_STORAGE_AREAS_ARE_APPROPRIATELY_DESIGNED_CONSTRUCTED_A',
                'CHEMICAL_STORAGE_AREAS_HAVE_MEASURES_IN_PLACE_TO_PREVENT_UNAUTH',
                'WHEN_NOT_IN_USE_ALL_CHEMICAL_CONTAINERS_ARE_PROPERLY_CAPPED_AND',
                'CHEMICAL_STORAGE_AREAS_WITH_FLAMMABLE_CHEMICALS_ARE_EQUIPPED_WI',
                'IN_CASES_OF_EMERGENCY_THERE_ARE_EASY_ENTRY_IES_AND_EXIT_S_TO_AL',
                'CHEMICAL_STORAGE_AREAS_HAVE_AN_ALARM_NOTIFICATION_SYSTEM',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-che-3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15270,
  sectionId: '2.2.9.5',
  impactArea: 'Chemicals and Hazardous Substances',
  impactAreaId: 'CHEMICALS_AND_HAZARDOUS_SUBSTANCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
